module.exports = __webpack_public_path__ + "img/live_sp-bg.fa21fe78.png";